import { render, staticRenderFns } from "./ProgramsForm.vue?vue&type=template&id=074a8884"
import script from "./ProgramsForm.vue?vue&type=script&lang=js"
export * from "./ProgramsForm.vue?vue&type=script&lang=js"
import style0 from "./ProgramsForm.vue?vue&type=style&index=0&id=074a8884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports